import { Medication } from "src/revamp/types/MedicationTypes";
import { Api } from "./api";
import { getRecordId } from "@utils/helpers";
import { AxiosResponse } from "axios";

export default class MedicationService {
	static searchMedications(searchQuery: string) {
    return Api.get('/photon/medications/search', { params: { query: searchQuery } });
  }

  /**
   * Get medications for a user
   * @param userId the user id
   */
  static getPatientMedications(userId: string): Promise<AxiosResponse<Medication[]>> {
    return Api.get(`/photon/medications/patient/${userId}`);
  }

  static addMedication(userId: string, medication: object) {
    return Api.post(`/photon/medication/patient/${userId}`, medication);
  }

  /**
   * Update a medication
   * @param userId the user id
   * @param medication the medication to update
   */
  static updateMedication(userId: string, medication: any) {
    return Api.put(`/photon/medication/patient/${userId}/${getRecordId(medication)}`, medication);
  }

  /**
   * Delete a medication
   * @param userId the user id
   * @param medicationId the medication id to delete
   */
  static deleteMedication(userId: string, medicationId: string) {
    return Api.delete(`/photon/medication/patient/${userId}/${medicationId}`);
  }
}